const MAX_BREADCRUMBS = 10
const breadcrumbs = []

export function debugLog(message, payload = {}) {
  if (sessionStorage.getItem('is_debug') ?? false) {
    if (Object.keys(payload).length === 0) {
      console.log(message)
    } else {
      console.log(message, payload)
    }
  }
}

export function logUserAction(event) {
  breadcrumbs.push({
    ...event,
    timestamp: new Date().toISOString(),
  })
  if (breadcrumbs.length > MAX_BREADCRUMBS) {
    breadcrumbs.shift()
  }
}

export function getBreadcrumbs() {
  return [...breadcrumbs]
}

export async function landingPageLogUsingPortal(message, payload = undefined) {
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }

  return window.axios.post(
    '/index.php?controller=landingpage&action=landing-page-log',
    window.qs.stringify({
      message,
      payload,
    }),
    config,
  )
}

export function sendError(item) {
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }
  const payload = {
    error: item,
    breadcrumbs: JSON.stringify(getBreadcrumbs()),
  }
  window.axios
    .post(
      '/index.php?controller=landingpage&action=error-log',
      window.qs.stringify({
        payload: JSON.stringify(payload),
      }),
      config,
    )
    .then(function (response) {
      if (response.status !== 200) {
        setTimeout(function () {
          sendError(item)
        }, 3000)
      }
    })
    .catch(function (_error) {
      setTimeout(function () {
        sendError(item)
      }, 3000)
    })
}
